/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, December 29th 2021, 10:42:46 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { PreBuiltServicesList } from "prebuilt-services/components/PreBuiltServicesList";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { OSDialogCloseButton } from "ui-widgets/dialogs/OSDialogCloseButton";
import { PreBuiltServiceCategorySelector, useCategorySelectionState } from "./PreBuiltServiceCategorySelector";

export const MarketPlaceComponent = (props: Pick<DialogProps, "open" | "onClose">) => {
  const { selectedCategoryId, onSelectAllCategories, onSelectCategory } = useCategorySelectionState();

  return (
    <Dialog
      aria-labelledby="marketplace-dialog-title"
      aria-describedby="marketplace-dialog-description"
      fullWidth
      maxWidth="xl"
      {...props}
    >
      <div className="os-marketplace-wrapper">
        <div className="os-marketplace-wrapper-header">
          <DialogTitle id="marketplace-dialog-title">
            <Typography className="os-modal-title" variant="h5">
              Service Templates Marketplace
            </Typography>
            <div className="os-modal-title-tabs">
              <div className="os-prebuilt-service-category-selector">
                <PreBuiltServiceCategorySelector
                  selectedCategoryId={selectedCategoryId}
                  onSelectItem={onSelectCategory}
                  onSelectAll={onSelectAllCategories}
                />
              </div>
            </div>
            <OSDialogCloseButton onClick={(e) => props.onClose(e, "backdropClick")} />
          </DialogTitle>
        </div>
        <div className="os-marketplace-wrapper-content">
          <DialogContent>
            <PreBuiltServicesList categoryId={selectedCategoryId} />
          </DialogContent>
        </div>
      </div>
    </Dialog>
  );
};
